<mat-form-field customColor="light" appearance="outline" [subscriptSizing]="subscriptSizing"
  [class.has-value]="hasValue" [class.opened]="opened">
  @if (label) {<mat-label>{{ label }}</mat-label>}
  <mat-select [formControl]="control" [placeholder]="placeholder" (openedChange)="onOpenedChange($event)">
    @for (option of options; track option) {
    <mat-option [value]="option.value">
      {{ option.viewValue }}
    </mat-option>
    }
  </mat-select>
  @if (control?.invalid && control?.errors) {
  <mat-error>{{ errorLabel }}</mat-error>
  }
  @if (hint) {
  <mat-hint>{{ hint }}</mat-hint>
  }
</mat-form-field>